import script from "./AdstxtMissingLinesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdstxtMissingLinesModal.vue?vue&type=script&setup=true&lang=js"

import "./AdstxtMissingLinesModal.vue?vue&type=style&index=0&id=2f1ae593&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1ae593"]])

export default __exports__